import { useNavigate } from 'react-router-dom'

import { TimePlanningEmployeesIndexPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import PlanningVersions from 'modules/time_planning/pages/PlanningVersionsPage'

const IndexPage = () => {
  const { navigation } = useNavigation()

  const { id, planningVersionId } = useStrictParams<'id' | 'planningVersionId'>()
  const navigate = useNavigate()

  const { data, loading } = useQuery(TimePlanningEmployeesIndexPageDocument, {
    variables: {
      employeeId: Number(id),
      planningVersionId: Number(planningVersionId),
    },
  })

  const authorized = data?.employees.employee?._policies?.seePlanningVersions?.can
  const currentPlanningVersionId = data?.timePlanning.planningVersionsConnection.nodes[0]?.id

  useUnsafeEffect(() => {
    if (!authorized) {
      navigate(navigation.employees.id.fullPath({ id }))
    }
  }, [id, authorized])

  useUnsafeEffect(() => {
    if (!planningVersionId) {
      navigate(
        navigation.employees.id.planningVersions.planningVersionId.fullPath({
          id,
          planningVersionId: currentPlanningVersionId ?? 0, // 0 is the default planning version
        })
      )
    }
  }, [id, planningVersionId, currentPlanningVersionId])

  if (loading) return <Loading />

  return <PlanningVersions />
}

export default IndexPage
